import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import arrivalIconImg from 'images/arrival_icon.png';
import runningImg from 'images/running.png';

const data = [
  {
    title: 'ddddddddd',
    width: '100',
    percent: '100',
    position: '93',
    num: '10',
  },
  { title: 'ddsdfs', width: '80', percent: '80', position: '70', num: '8' },
  {
    title: 'ddddddfsdfsdddd',
    width: '20',
    percent: '20',
    position: '10',
    num: '2',
  },
];

const type = { group: '그룹 챌린지', campaign: '루틴 챌린지' };

export default function MyPageProjectAchieve({ projectsrate }) {
  return (
    <MypageAchieveInner>
      <Maintit>챌린지 달성률</Maintit>

      <Slidearea>
        {projectsrate.map((value, index) => {
          return (
            <SlideBoxNext
              key={`${value['item_type']}-project-item-no-${value['no']}`}
              groupNo={`${value['group_no']}`}
              itemNo={`${value['no']}`}
              title={value.title}
              percent={value.rate}
              width={value.rate}
              position={
                Math.round(value.rate) == 0
                  ? Math.round(value.rate)
                  : Math.round(value.rate) - 5
              }
              num={value.submitted_task}
              totalNum={value.total_task}
              itemType={value.item_type}
            />
          );
        })}
      </Slidearea>
    </MypageAchieveInner>
  );
}

function SlideBoxNext({
  itemNo,
  title,
  percent,
  width,
  position,
  num,
  itemType,
  totalNum,
  groupNo
}) {
  let projectLink = null;
  if (itemType === 'group') {
    projectLink = `group/${groupNo}/project/${itemNo}`;
  } else if (itemType === 'campaign') {
    projectLink = `campaign/${itemNo}`;
  }
  return (
    <Slidebx>
      <ProjectLink to={projectLink}>
        <SlideTitBox>
          <SlideTit>{title}</SlideTit>
          <SlideTitsub>{type[itemType]}</SlideTitsub>
        </SlideTitBox>
        <ProgressbarTit>
          전체 달성률 <Num>{num}</Num>/{totalNum}
        </ProgressbarTit>
        <ProgressbarInnerBar>
          <Progressbarbox>
            <ProgressbarIcon position={position} />
            <ProgressbarLine width={width} />
          </Progressbarbox>
          <Percent>{percent}%</Percent>
          <Arrival>
            <img src={arrivalIconImg}></img>
          </Arrival>
        </ProgressbarInnerBar>
      </ProjectLink>
    </Slidebx>
  );
}

const MypageAchieveInner = styled.div`
  padding: calc(100vw * (31 / 375)) 0 0 calc(100vw * (17 / 375));
  overflow: hidden;
`;

const ProjectLink = styled(Link)``;
const Maintit = styled.p`
  font-size: calc(100vw * (16 / 375));
  font-weight: bold;
  padding-bottom: calc(100vw * (24 / 375));
`;

const Slidearea = styled.div`
  display: flex;
  overflow-x: scroll;
  margin-right: calc(100vw * (10 / 375));
  height: calc(100vw * (120 / 375));
`;
const SlideTitBox = styled.p`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SlideTit = styled.span`
  display: block;
  max-width: calc(100vw * (225 / 375));
  height: calc(100vw * (20 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  color: #121212;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-bottom: calc(100vw * (5 / 375));
`;
const SlideTitsub = styled.span`
  display: inline-block;
  height: calc(100vw * (19 / 375));
  line-height: calc(100vw * (17 / 375));
  border-radius: calc(100vw * (10 / 375));
  border: solid calc(100vw * (1 / 375)) #707070;
  padding: 0 calc(100vw * (10 / 375));
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  letter-spacing: 0.24px;
  color: #4e4e4e;
  background: #fff;
`;
const ProgressbarTit = styled.p`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  letter-spacing: 0.24px;
  color: #707070;
  margin-bottom: calc(100vw * (36 / 375));
`;
const Num = styled.span`
  color: #707070;
`;
const Slidebx = styled.div`
  width: calc(100vw * (336 / 375));
  height: calc(100vw * (113 / 375));
  border-radius: calc(100vw * (9 / 375));
  box-shadow: 0 calc(100vw * (3 / 375)) calc(100vw * (6 / 375)) 0
    rgba(213, 213, 213, 0.64);
  border: solid calc(100vw * (1 / 375)) #eaeaea;
  background-color: #ffffff;
  padding: calc(100vw * (13 / 375)) calc(100vw * (13 / 375))
    calc(100vw * (15 / 375)) calc(100vw * (12 / 375));
  margin-right: calc(100vw * (10 / 375));
`;
const ProgressbarInnerBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Progressbar = styled.div`
  position: relative;
  width: calc(100vw * (287 / 375));
  height: calc(100vw * (6 / 375));
  border-radius: calc(100vw * (11 / 375));
  background-color: #ebebeb;

  &::before {
    content: '‍';
    position: absolute;
    top: calc(100vw * (-20 / 375));
    left: 0;
    width: calc(100vw * (17 / 375));
    height: calc(100vw * (19 / 375));
    animation: position 2s forwards ease-out;
    background-image: url(${runningImg});
    background-size: calc(100vw * (17 / 375)) calc(100vw * (19 / 375));
    background-repeat: no-repeat;
  }
  &::after {
    content: '‍';
    position: absolute;
    top: 0;
    left: 0;
    width: 0%;
    height: 100%;
    background-color: #ffcf19;
    border-radius: calc(100vw * (11 / 375));
    animation: progressbar 2s forwards ease-out;
  }
  @keyframes progressbar {
    0% {
      width: 0%;
    }
    100% {
      width: ${(props) => props.width}%;
    }
  }
  @keyframes position {
    0% {
      left: 0%;
    }
    100% {
      left: ${(props) => props.position}%;
    }
  }
`;
const Progressbarbox = styled.div`
  position: relative;
  width: calc(100vw * (287 / 375));
  height: calc(100vw * (6 / 375));
  border-radius: calc(100vw * (11 / 375));
  background-color: #ebebeb;
`;
const ProgressbarIcon = styled.div`
  position: absolute;
  top: calc(100vw * (-20 / 375));
  left: ${(props) => props.position}%;
  width: calc(100vw * (17 / 375));
  height: calc(100vw * (19 / 375));
  background-image: url(${runningImg});
  background-size: calc(100vw * (17 / 375)) calc(100vw * (19 / 375));
  background-repeat: no-repeat;
`;
const ProgressbarLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => props.width}%;
  height: 100%;
  background-color: #ffcf19;
  border-radius: calc(100vw * (11 / 375));
`;

const Percent = styled.span`
  font-size: calc(100vw * (9 / 375));
  font-weight: 500;
  color: #989898;
  margin-left: calc(100vw * (5 / 375));
`;

const Arrival = styled.span`
  position: absolute;
  top: calc(100vw * (-15 / 375));
  right: calc(100vw * (18 / 375));
  display: block;
  width: calc(100vw * (11.5 / 375));
  height: calc(100vw * (16.4 / 375));
`;
